
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLeadSubmission } from "@/hooks/useLeadSubmission";
import { useFormNotifications } from "@/hooks/useFormNotifications";

const HeroForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const { submitLead, isSubmitting } = useLeadSubmission();
  const { notifyNameEmailSubmission } = useFormNotifications();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || !email) return;
    
    // Fire GTM event for name/email submission
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: 'cta_name_email_submit' });
    }
    
    // Send to Telegram
    await notifyNameEmailSubmission(name, email, 'hero_form');
    
    const success = await submitLead(`${name} - ${email}`, 'hero_form');
    if (success) {
      setName("");
      setEmail("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        type="text"
        placeholder="Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="border-[#747DA1] focus:border-[#D9992B] focus:ring-[#D9992B] bg-[#2B2F4A] text-[#F4F4F4] placeholder:text-[#747DA1]"
        required
      />
      <Input
        type="email"
        placeholder="Your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="border-[#747DA1] focus:border-[#D9992B] focus:ring-[#D9992B] bg-[#2B2F4A] text-[#F4F4F4] placeholder:text-[#747DA1]"
        required
      />
      <Button 
        type="submit"
        disabled={isSubmitting}
        className="w-full text-[#F4F4F4] py-3 text-lg font-semibold transition-all duration-300 hover:shadow-lg"
        style={{ backgroundColor: '#D9992B' }}
      >
        {isSubmitting ? "Submitting..." : "Get Free Consultation"}
      </Button>
    </form>
  );
};

export default HeroForm;
